import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import LockIcon from '@material-ui/icons/Lock'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Routes } from 'app/services/routeService/routeService'

import Box from 'app/componentV4/Box'

const useStyles = makeStyles((theme) => ({
  lockIcon: ({ iconSize }) => ({
    fontSize: iconSize === 'sm' ? '2.4rem' : '5.6rem',
  }),
  title: {
    color: theme.palette.darkGrey.main,
    fontSize: '1.4rem',
  },
  subtitle: {
    color: theme.palette.darkGrey.main,
    fontSize: '1.0rem',
  },
}))

const PaidPlanAccessBlockV4 = ({ titleId, subtitleId, iconSize }) => {
  const classes = useStyles({ iconSize })

  const messageValues = {
    l: (text) => (
      <Link
        to={Routes.billingchangePlan()}
        className="underline bg-transparent justify-center px-3 text-14 font-bold cursor-pointer text-secondary"
      >
        {text}
      </Link>
    ),
  }

  return (
    <Box className="w-full">
      <div className="flex items-center">
        <LockIcon style={{ fontSize: 32 }}>lock</LockIcon>
        <Typography className="px-5">
          <FormattedMessage id={titleId} values={messageValues} />
          {subtitleId && (
            <span className={clsx(classes.subtitle, 'mt-8 leading-snug')}>
              <FormattedMessage id={subtitleId} values={messageValues} />
            </span>
          )}
        </Typography>
      </div>
    </Box>
  )
}

PaidPlanAccessBlockV4.propTypes = {
  titleId: PropTypes.string,
  iconSize: PropTypes.string,
  subtitleId: PropTypes.string,
}

export default PaidPlanAccessBlockV4
